var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 31,
    viewBox: "0 0 34 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 22.1665C19.7611 22.1665 21.9995 19.9281 21.9995 17.1667C21.9995 14.4054 19.7611 12.167 16.9998 12.167C14.2384 12.167 12 14.4054 12 17.1667C12 19.9281 14.2384 22.1665 16.9998 22.1665Z",
    stroke: "#757576",
    strokeWidth: 3.33317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 23.4995V10.8335C2 8.96673 2 8.03335 2.3633 7.32035C2.68285 6.69316 3.19276 6.18325 3.81994 5.8637C4.53294 5.5004 5.46633 5.5004 7.33307 5.5004H9.09072C9.29561 5.5004 9.39805 5.5004 9.49256 5.48957C9.9857 5.43309 10.428 5.15974 10.6991 4.74393C10.751 4.66423 10.7968 4.57258 10.8884 4.38934C11.0717 4.02284 11.1633 3.83959 11.2672 3.6802C11.8093 2.84857 12.6939 2.30186 13.6803 2.18889C13.8692 2.16724 14.0741 2.16724 14.4839 2.16724H19.5146C19.9244 2.16724 20.1293 2.16724 20.3183 2.18889C21.3045 2.30186 22.1892 2.84857 22.7313 3.6802C22.8351 3.83957 22.9268 4.02289 23.1101 4.38934C23.2016 4.5726 23.2474 4.66423 23.2994 4.74393C23.5706 5.15974 24.0127 5.43309 24.5059 5.48957C24.6005 5.5004 24.7029 5.5004 24.9079 5.5004H26.6654C28.5322 5.5004 29.4656 5.5004 30.1786 5.8637C30.8057 6.18325 31.3157 6.69316 31.6352 7.32035C31.9985 8.03335 31.9985 8.96673 31.9985 10.8335V23.4995C31.9985 25.3663 31.9985 26.2997 31.6352 27.0127C31.3157 27.6398 30.8057 28.1498 30.1786 28.4693C29.4656 28.8326 28.5322 28.8326 26.6654 28.8326H7.33307C5.46633 28.8326 4.53294 28.8326 3.81994 28.4693C3.19276 28.1498 2.68285 27.6398 2.3633 27.0127C2 26.2997 2 25.3663 2 23.4995Z",
    stroke: "#757576",
    strokeWidth: 3.33317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.8d1e3c5a5e72048f675e511581959765.svg";
export { ForwardRef as ReactComponent };